var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.showPrefix)?[_vm._v(_vm._s(_vm.prefix))]:_vm._e(),_vm._v(_vm._s(_vm.numeral))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }